// extracted by mini-css-extract-plugin
module.exports = {"root":"Tabs_root__1dZMr","item":"Tabs_item__33UGu","active":"Tabs_active__29qtN","success":"Tabs_success__1ulAs","spinAround":"Tabs_spinAround__2O2WP"};